import React from 'react';

import RegistrationBonusPopup from 'common/Popup/RegistrationBonusPopup/RegistrationBonusPopup';
import QueryRouter from 'common/QueryRouter/QueryRouter';
import EmailVerificationPopup from 'components/Auth/EmailVerificationPopup';
import { PopupSignUpDelay } from 'components/Auth/PopupSignUpDelay';
import SingleSignUp from 'src/components/Auth/SingleSignUp';
import Smartico from 'components/ClientProfile/Achievements/Smartico';

const QueryRoutes = () => (
  <>
    <QueryRouter command="signup-delay">
      <PopupSignUpDelay />
    </QueryRouter>
    <QueryRouter command="signup-bonuses">
      <RegistrationBonusPopup />
    </QueryRouter>
    <QueryRouter command="emailVerification">
      <EmailVerificationPopup />
    </QueryRouter>
    <QueryRouter command="achievements">
      <Smartico onlyModal={true} />
    </QueryRouter>
    <QueryRouter command="signup">
      <SingleSignUp />
    </QueryRouter>
  </>
);

export default QueryRoutes;
